import { render, staticRenderFns } from "./ThermometerIcon.vue?vue&type=template&id=20450e8a&scoped=true&"
import script from "./ThermometerIcon.vue?vue&type=script&lang=js&"
export * from "./ThermometerIcon.vue?vue&type=script&lang=js&"
import style0 from "./ThermometerIcon.vue?vue&type=style&index=0&id=20450e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20450e8a",
  null
  
)

export default component.exports